module.exports = __webpack_public_path__ + "img/icon-192x192.94cd9e97.png";